export class ListOfTeamleaderAssignmentResponse {
	teamleader_id: number;
	EditAbsent: number;
	EditBooking: number;
	persnr?: number;
}
